import React from "react";
import { Modal } from "react-bootstrap";
import "./LeaveQuickEntryModal.scss";

export interface LeaveQuickEntryModalProps {
    readonly show: boolean;
    /** "Stay in Quick Entry" - cancel/ghost. No data lost (AC11). */
    readonly onCancel: () => void;
    /** "Switch to Classic Mode" - primary. Sets classicModeOverride = true (AC11/AC12). */
    readonly onConfirm: () => void;
}

/**
 * "Leave Quick Entry?" exit dialog (Spec #34102 / F1d, AC11). Copy is
 * verbatim per the v6 mockup / decision #4 - do not paraphrase when editing.
 *
 * Markup/icons mirror the v6 mockup's "#classic-modal" confirm-dialog
 * (uploads/master-demo-v6.html, "Classic Mode confirmation dialog") -
 * rotate-back icon, info-circle callout - styled in LeaveQuickEntryModal.scss.
 */
const LeaveQuickEntryModal: React.FC<LeaveQuickEntryModalProps> = (props) => {
    return (
        <Modal show={props.show} onHide={props.onCancel} className="leave-quick-entry-modal" centered>
            <div className="leave-quick-entry-modal__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7}>
                    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3 3v5h5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <Modal.Header>
                <Modal.Title>Leave Quick Entry?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="leave-quick-entry-modal__body">
                    You&apos;ll return to the standard data entry form. Classic Mode opens as a clean slate &mdash; AI-extracted
                    values are not carried over &mdash; but the attached document stays with the request.
                </p>
                <div className="leave-quick-entry-modal__note">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
                        <circle cx={12} cy={12} r={9} />
                        <path d="M12 8h.01M11 12h1v4h1" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Classic Mode stays available if AI extraction fails or stalls.</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="leave-quick-entry-modal__stay-btn" onClick={props.onCancel}>
                    Stay in Quick Entry
                </button>
                <button type="button" className="leave-quick-entry-modal__switch-btn" onClick={props.onConfirm}>
                    Switch to Classic Mode
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default LeaveQuickEntryModal;
